import React from 'react';
import { BackButton, Card, PageHeader } from 'ui';
import { useAuth } from '../../context/auth-context';

export default function ErrorFallbackBun() {
  const auth = useAuth();
  return <main className="bun flex min-h-screen items-center justify-center px-4 py-8">
    <Card className="w-full max-w-md">
      <Card.Section className="space-y-5">
        <PageHeader title="Whoops, looks like something went wrong!" />
        <p className="m-0 text-bun-body font-book leading-relaxed text-bun-stone">Sorry about the issue! Please try again.</p>
        <BackButton as="a" href={auth?.currentUser ? '/dashboard' : '/'} compactOnMobile={false}>Go back home</BackButton>
      </Card.Section>
    </Card>
  </main>;
}
